import React from "react";
import { useNavigate } from "react-router-dom";
import NotFound404 from "./loyalty/components/NotFound404";
import { Button } from "components";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return <NotFound404 />;
};

export default NotFound;
